import styled from 'styled-components';
import { Tag } from 'antd';
import { getTextStyle } from 'utils/getTextStyle';
import { TagProps } from 'antd/lib';

type AppTagProps = TagProps;

export const StyledTag = styled(Tag)`
    ${getTextStyle('BodySmallSemiBold')};
    padding: 4px 12px;
    border-radius: 4px;
    margin-inline-end: 0;
    border-width: 0;
`;

export const AppTag = (props: AppTagProps) => <StyledTag {...props} />;
